import { render } from "./attendance-reports-filter.vue?vue&type=template&id=1ba1e924"
import script from "./attendance-reports-filter.vue?vue&type=script&lang=js"
export * from "./attendance-reports-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__